import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import arrow from "../../assets/arrowDown.png";

const ImageSlider = ({ images, interval = 8000, showImageGrid = true }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [thumbStartIndex, setThumbStartIndex] = useState(0);
  const THUMB_COUNT = 4;
  useEffect(() => {
    // Reset slider index when the image list changes
    setCurrentIndex(0);
    setThumbStartIndex(0);
  }, [images]);

  const [isMobile, setIsMobile] = useState(window.innerWidth < 700);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 700);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const sliderInterval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }, interval);

    return () => clearInterval(sliderInterval); // ✅ Clear on every currentIndex change
  }, [currentIndex, images.length, interval]); // ✅ currentIndex is included here

  const goToSlide = (index) => {
    setCurrentIndex(index);
    if (index < thumbStartIndex) {
      setThumbStartIndex(index);
    } else if (index >= thumbStartIndex + THUMB_COUNT) {
      setThumbStartIndex(index - THUMB_COUNT + 1);
    }
  };

  const visibleThumbnails =
    images.length <= THUMB_COUNT || isMobile
      ? images
      : images.slice(thumbStartIndex, thumbStartIndex + THUMB_COUNT);

  return (
    <div className="relative w-full h-full overflow-hidden images-slider">
      <div className="slider-overlay"></div>
      <motion.div
        className="flex w-full h-full slider"
        initial={{ x: 0 }}
        animate={{ x: `-${currentIndex * 100}%` }}
        transition={{ duration: 0.5, ease: "easeInOut" }}
      >
        {images.map((image, index) => (
          <motion.img
            key={index}
            src={image}
            alt={`Slide ${index + 1}`}
            style={{ minWidth: "100%", minHeight: "100%" }}
            className="w-full h-full object-cover slider-image"
          />
        ))}
      </motion.div>

      {showImageGrid && (
        <div className="slider-image-grid  mt-4 flex items-center thumbnail-scroll-container">
          {/* Left button only if more than 4 images */}

          <img
            src={arrow}
            alt="Left"
            className="slider-arrow left-slider-arrow arrow-desktop"
            onClick={() => setThumbStartIndex(Math.max(0, thumbStartIndex - 1))}
          />

          {/* Thumbnails */}
          {visibleThumbnails.map((image, i) => {
            const actualIndex =
              isMobile || images.length <= THUMB_COUNT
                ? i
                : thumbStartIndex + i;

            return (
              <img
                key={actualIndex}
                src={image}
                alt={`Thumbnail ${actualIndex + 1}`}
                className={`w-16 h-16 object-cover mx-1 cursor-pointer ${
                  currentIndex === actualIndex
                    ? "border-2 border-orange-500"
                    : ""
                }`}
                onClick={() => goToSlide(actualIndex)}
              />
            );
          })}

          {/* Right button only if more than 4 images */}

          <img
            src={arrow}
            alt="Right"
            className="slider-arrow right-slider-arrow arrow-desktop"
            onClick={() =>
              setThumbStartIndex(
                Math.min(images.length - THUMB_COUNT, thumbStartIndex + 1)
              )
            }
          />
        </div>
      )}
    </div>
  );
};

export default ImageSlider;
